<style scoped lang="less">
	.deletrains {
		border: 1px solid;
		border-radius: 3px;
		width:8%;
		// height: 4vh;
		margin-left: 3vw;
		text-align: center;
		padding: 0.2rem 0;
		background-color: red;
		color: #fff;
		background-color: #FF8300;
		font-size: 0.8vw;
		// transform: translateX(%);
		cursor: pointer;
	}


	@media (min-width: 380px) {
		.col-md-12 {
			.filtersstitle {
				width: 10%;
			}
		}
	}

	@media (min-width: 768px) {
		.col-md-12 {
			.filtersstitle {
				width: 10%;
			}
		}
	}


	@media (min-width: 1280px) {
		.col-lg-12 {
			.filtersstitle {
				width: 5%;
			}
		}
	}



	.filters {
		width: 100%;
		background-color: #fff;
		border-radius: 5px;
		padding: 0.8rem 0.8rem 0.8rem 0;
		border-left: 0.4rem solid #348FE2;
		box-sizing: border-box;



		.childsactive {
			color: #fff !important;
			background: #30C8C6;
			border-radius: 5px;
		}

		/deep/ .el-input__suffix {
			top: -6px;
		}



		.filterstitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0 0 1rem 1rem;

			.filterstitle1 {
				display: flex;
				align-items: center;

				.roomesicon {
					width: 3rem;
					height: 3rem;
					line-height: 3rem;
					text-align: center;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #fff;
					font-size: 1.8rem;
					margin-right: 0.8rem;
					background-color: #29CA8E;
				}

				.roomcontent {
					margin-top: 0.6rem;
					color: #4B4B4B;
					
				}

				.roomsname {
					font-size: 1.2rem;
					color: #333333;
					font-weight: 700;
					margin-right: 0.4rem;
				}
			}

			.filterstitle2 {
				margin-right: 1.5rem;

				input {
					border: 1px solid #ccc;
					padding: 0.4rem 1rem;
					border-radius: 2px;
					border-right: none;
				}

				button {
					padding: 0.45rem 1rem;
					border-top-right-radius: 2px;
					border-bottom-right-radius: 2px;
					color: #fff;
					background: #FF8300;
				}

				button:hover {
					background: #d46a00;
				}

			}

		}

		.filtersschool {
			width: 100%;

			white-space: nowrap;

			.filterssitem {
				display: flex;
				align-items: center;
				width: 100%;
				margin: 1rem 0;
				flex-wrap: wrap;

				.filtersstitle {
					font-size: 0.8rem;
					color: #000;
					font-weight: 700;
					margin: 0;
					padding: 0;
					width: 6rem;
					text-align: right;
				}

				.itemchilds {
					padding: 2px 10px;
					margin: 0 10px;
					font-size: 0.8rem;
					color: #4B4B4B;

				}

			}
		}

	}

	.filtimer {
		/deep/ .el-input__inner {
			height: 1.6rem;
		}

		/deep/ .el-input__prefix {
			top: -8px;
		}

		/deep/ .el-input {
			width: 10rem;
		}

		span {
			margin: 0 1rem;
		}

	}

	.selebtn {
		margin: 2rem 2rem 0;
		padding-left: 3%;
		box-sizing: border-box;
		border-top: 1px solid #ccc;

		button:first-child {
			background: #2EBF91;
		}

		button:nth-of-type(2) {
			background: #FFA319;
		}

		button:last-child {
			background: #AAAAAA;
			color: #fff;

			span {
				color: #fff;
			}
		}

		button {
			padding: 0.5rem 1rem;
			// width: 7rem;
			font-size: 0.8rem;

			span {
				margin-left: 2px;
			}

			color: #fff;
			background: #FFA319;
			margin: 1rem 0.6rem 1rem 0;
			border-radius: 4px;
		}
	}
</style>
<template>
	<div>
		<div class="filters">
			<div class="filterstitle">
				<div class="filterstitle1">
					<!-- <img src="@/images/testroom.png" alt=""> -->
					<div v-if="roomes.name=='实训室'" class="roomesicon">
						<span class="fas fa-hard-drive"></span>
					</div>
					<p class="roomsname">{{roomes.name}}</p>
					<span class="roomcontent">{{roomes.content}}</span>
				</div>
				<div class="filterstitle2">
					<input v-model="searchs"  type="text" placeholder="搜索感兴趣的实训室" maxlength="10">
					<button type="button" @click="searchsx()" v-preventReClick>
						<span class="fa fa-search"></span>
					</button>
				</div>
			</div>
			<div class="filtersschool col-xs-12 col-md-12 col-lg-12">
				<div class="filterssitem sollore" v-for="(item,index) in roomes.filterlist" :key="index">
					<p class="filtersstitle">{{item.title}}:</p>
					<div class="itemchilds" style="cursor: pointer;" v-for="(ite,ind) in item.childers" :key="ind"
						@click="changechilds(ind,index,ite,item)" :class="{childsactive:ind==item.indexsshol}">
						{{ite.name}}
						<div class="filtimer" style="display: flex;align-items: center;" v-if="ite.titlechoice==1">
							<div class="block">
								<el-date-picker v-model="begintimer" type="date" placeholder="选择日期">
								</el-date-picker>
							</div>
							<span>---</span>
							<div class="block">
								<el-date-picker v-model="endtimer" type="date" placeholder="选择日期">
								</el-date-picker>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div style="display: flex;align-items: center;">
				<p v-powershow="powershowobj" class="deletrains" @click="alldelect()">批量删除</p>
				<p class="deletrains" style="margin-left: 1vw;background-color:#29CA8E;" @click="gotrain()">新增实训室</p>
			</div>
			
		</div>
	</div>
</template>

<script>
	import $ from "jquery"


	export default {
		props: {
			rooms: Object,

		},
		data() {
			return {
				roomes: this.rooms,
				begintimer: "",
				endtimer: "",
				// 屏幕尺寸
				screenWidth: document.body.clientWidth,
				// 判断滚动条
				searchs: "",
				// 查询条件
				sxtrguid: "",
				sxteguid: "",
				claguid: "",
				// 动态权限指令
				powershowobj:{}

			}
		},
		created() {
			this.$cookie.set("sxsi_guid", '')
			this.$cookie.set("sxtrguid", '')
			// console.log("进入穿件")
			let powerlist = JSON.parse(window.sessionStorage.getItem("allbtnlist"))
			this.powershowobj.powershows = powerlist
			this.powershowobj.routers = this.$route.path
		},
		methods: {
			gotrain(){
				this.$router.push("/device/addmanges")
			},
			
			alldelect() {
				this.$parent.alldelect()
			},
			// 查询预约记录
			selectjl() {
				this.$parent.changetable()
			},
			// 查询实训记录
			selectjlsx() {
				this.$parent.changetables()
			},
			// 重置
			catevh() {
				console.log("重置")
			},
			// 搜索
			searchsx() {
				this.$parent.getTrainRoom(this.searchs)
			},

			changechilds(i, id, itm, item) {
				console.log(itm)
				this.roomes.filterlist[id].indexsshol = i
				// console.log(this.$parent,"指向")
				// console.log(itm.si_guid)
				this.$parent.changeschoolif(itm.si_guid)

			},
			// 移动端适配
			relazy() {
				const that = this
				window.onresize = () => {
					return (() => {
						window.screenWidth = document.body.clientWidth
						that.screenWidth = window.screenWidth
						if (that.screenWidth < 1450) {
							// console.log("到限定宽度")
							console.log(document.querySelector(".itemchilds"))
							// $(".itemchilds").css("margin-top", "10px")
							// $(".filtersstitle").css("margin-top", "10px")
						}
					})()
				}
				if (that.screenWidth < 1450) {
					// $(".itemchilds").css("margin-top", "10px")
					// $(".filtersstitle").css("margin-top", "10px")
				}
			}
		},
		mounted() {
			this.relazy()
		}

	}
</script>

<style>
</style>
